import Vue from 'vue';
import Plyr from 'plyr/dist/plyr.polyfilled';
export default Vue.extend({
    props: {
        block: Object
    },
    mounted: function () {
        if (this.$refs.player) {
            new Plyr(this.$refs.player);
        }
        if (this.$refs.player2) {
            new Plyr(this.$refs.player2);
        }
    },
    methods: {
        getPlyrProvider: function (videoUrl) {
            return videoUrl.includes('youtu') ? 'youtube' : 'vimeo';
        }
    }
});
